import LegalPageLayout from "@/components/LegalPageLayout";

const H = ({ children }) => (
  <h2 className="mt-8 font-serif text-2xl text-navy">{children}</h2>
);

export default function RefundPolicy() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Refund Policy"
      lastUpdated="February 2026"
      testId="refund-policy-page"
    >
      <div className="rounded-md border border-gold/40 bg-[#FBF7EE] p-5">
        <p className="text-sm font-semibold uppercase tracking-[0.15em] text-navy">
          All payments are strictly non-refundable.
        </p>
      </div>

      <H>1. No Refunds</H>
      <p>
        All amounts paid to WillSeva for any service, including the Essential Will
        and the Lawyer Review add-on, are <strong>non-refundable</strong> once paid.
      </p>

      <H>2. No Refund Scenarios</H>
      <p>Refunds will not be issued once any of the following has occurred:</p>
      <ul className="ml-5 list-disc space-y-1">
        <li>The intake / wizard has been started</li>
        <li>Drafting has been initiated</li>
        <li>The document has been generated</li>
        <li>The lawyer review process has begun</li>
        <li>A consultation has been scheduled</li>
      </ul>

      <H>3. Reasons that do not qualify for a refund</H>
      <p>
        WillSeva will not issue refunds for any of the following reasons:
      </p>
      <ul className="ml-5 list-disc space-y-1">
        <li>Change of mind after payment</li>
        <li>Dissatisfaction with the platform, document or service</li>
        <li>Incorrect, incomplete or misleading information supplied by the user</li>
        <li>Incomplete usage of the platform or its features</li>
        <li>User delay, non-responsiveness or failure to complete next steps</li>
      </ul>

      <H>4. Technical Duplicates</H>
      <p>
        Duplicate or genuinely failed technical payments may be reviewed and
        addressed at the sole discretion of WillSeva. Any such refund, if approved,
        will be processed only to the original payment instrument.
      </p>

      <H>5. Acknowledgement</H>
      <p>
        By proceeding with payment, the user acknowledges and agrees to this
        no-refund policy in full.
      </p>

      <H>Need help?</H>
      <p>
        If you have a billing question, please reach us via the{" "}
        <a className="font-medium text-navy underline" href="/contact">Contact Us</a>{" "}
        page or WhatsApp +91 9167249612.
      </p>
    </LegalPageLayout>
  );
}
